import { ChangeEvent, useCallback, useEffect, useState } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../_App/Redux/hooks";
import {
  SelectedOrganisationId,
  societeId,
} from "../../_App/Redux/Slices/Auth/authSlice";
import {
  findFidelitePrograms,
  findNiveauxFidelite,
  ListNiveauxFidelite,
  ListZones,
} from "../../_App/Redux/Slices/client/clientSlice";
import Select from "react-select";
import {
  findCarteBySocieteApi,
  findCartesApi,
  ListCartes,
} from "../../_App/Redux/Slices/cartes/carteSlice";
import {
  findCategorieBySocieteApi,
  findCategoriesApi,
  ListCategories,
  ListCategoriesByCarte,
} from "../../_App/Redux/Slices/categories/categorieSlice";
import {
  CategorieSousCategories,
  findSousCategorieBySocieteApi,
  findSousCategoriesApi,
  findSousCategoriesByCategorieApi,
  ListSousCategories,
  ListSousCategoriesByCategorie,
} from "../../_App/Redux/Slices/souscategories/souscategorieSlice";
import {
  findArticleByBarCode,
  findArticlebysocieteApi,
  findArticleParentCode,
  findArticleRefParentApi,
  ListArticles,
} from "../../_App/Redux/Slices/article/articleSlice";
import { ArticleType } from "../../_App/Types/Entites/ArticleType";
import { toast } from "react-toastify";
import { ConditionProduitType } from "../../_App/Types/Entites/RemiseType";
import { debounce } from "lodash";
import { parametrageCaisse } from "../../_App/Redux/Slices/AppParametrages/caisseParametrages/caisseParametrageSlice";
import { Spinner } from "react-bootstrap";
import ArticleListReference from "../../_Layouts/RightBar/RightBar/cart/ArticleListReference";

function ConditionForms({
  type,
  setConditionClient,
  setConditionProduit,
  setConditionAchat,
  solde,
  programFidelite,
}: any) {
  const { t } = useTranslation();
  const [rand, setRand] = useState(true);
  const dispatch = useAppDispatch();
  const currentOrg = useAppSelector(SelectedOrganisationId);
  const societe = useAppSelector(societeId);
  const niveaux = useAppSelector(ListNiveauxFidelite);
  const zones = useAppSelector(ListZones);

  const [inputValue, setInputValue] = useState("");
  const [inputParentValue, setInputParentValue] = useState("");

  const [article, setArticle] = useState<any>(null);
  const [min, setMin] = useState<number | null>(1);
  const [max, setMax] = useState<number | null>(1000);
  const [conditionProduitType, setconditionProduitType] = useState<
    string | null
  >("Quantité");
  const [fournisseur, setFournisseur] = useState(null);
  const [etOuclient, setEtOuclient] = useState<string | null>(null);
  const [etOuProduit, setEtOuProduit] = useState<string | null>(null);

  const [cumulableachat, setCumulableachat] = useState(false);
  const [cumulableproduit, setCumulableproduit] = useState(false);

  const [niveauClient, setNiveauClient] = useState<string[]>([]);
  const [pointsMin, setPointsMin] = useState<number | null>(null);
  const [zone, setZone] = useState<string | null>(null);
  const [montant, setMontant] = useState<number | null>(null);

  const currentOrganisation = useAppSelector(SelectedOrganisationId);

  const [selectedCarte, setSelectedCarte] = useState<any>(null);
  const [selectedCategorie, setSelectedCategorie] = useState<any>(null);
  const [selectedSousCategorie, setSelectedSousCategorie] = useState<any>(null);
  const [selectedSousCategorienom, setSelectedSousCategorienom] =
    useState<any>(null);

  const [indexcat, setindexcat] = useState(1);
  const [isOpen, setIsOpen] = useState(false);
  const [articleParent, setarticleParent] = useState(null);
  useEffect(() => {
    if (currentOrganisation) {
      dispatch(findCartesApi(currentOrganisation));
      dispatch(findCategoriesApi(currentOrganisation));
      const data = { index: 1, societe: societe };
      dispatch(findSousCategorieBySocieteApi(data));

      if (selectedCategorie)
        dispatch(findSousCategoriesByCategorieApi(selectedCategorie));
    }
  }, [rand, dispatch, selectedCategorie]);

  const showsouscategories = async (value: any) => {
    if (value === "more") {
      await dispatch(
        findSousCategorieBySocieteApi({
          societe: societe,
          index: indexcat + 12,
        }),
      );
      setindexcat(indexcat + 12);
    } else if (value === "up") {
      await dispatch(
        findSousCategorieBySocieteApi({
          societe: societe,
          index: indexcat - 12,
        }),
      );
      setindexcat(indexcat - 12);
    } else {
      setSelectedSousCategorie(value?._id);
      setSelectedSousCategorienom(value?.libelle?.fr);
      setIsOpen(false);
    }
  };

  console.log("articleParent", articleParent);
  const cartes = useAppSelector(ListCartes);
  const categories = useAppSelector(ListCategoriesByCarte);
  let sousCategories = useAppSelector(CategorieSousCategories);
  sousCategories = useAppSelector(ListSousCategories);

  const handleChange = (option: any, type: string) => {
    if (type === "carte") {
      setSelectedCarte(option.value);
    } else if (type === "categorie") {
      setSelectedCategorie(option.value);
    } else {
      setSelectedSousCategorie(option.value);
    }
  };
  const CartesOptions = cartes?.map((option) => ({
    value: option._id,
    label: option.libelle.fr,
  }));
  const categorieClientOptions = niveaux?.map((option) => ({
    value: option._id,
    label: option.libelle,
  }));

  const handleSelectChangecategorieClient = (selectedOption: any) => {
    const categories = selectedOption.map((item: any) => item.value);
    setNiveauClient(categories);
  };
  const categoriesdOptions =
    selectedCarte &&
    categories[selectedCarte]?.map((option) => ({
      value: option._id,
      label: option.libelle.fr,
    }));

  const sousCategoriesOptions =
    selectedCategorie &&
    sousCategories?.map((option) => ({
      value: option._id,
      label: option.libelle.fr,
    }));
  let conditionClient =
    (niveauClient && niveauClient.length > 0) || (zone && zone.length > 0)
      ? {
          niveau_fidelite: niveauClient,
          points_min: pointsMin,
          zone: zone,
          organisation_id: currentOrg,
          remise_id: type === "remise" ? "" : null,
          gratuite_id: type === "gratuite" ? "" : null,
          fidelite_id: type === "fidelite" ? "" : null,
        }
      : null;

  let conditionProduit =
    selectedCategorie ||
    selectedSousCategorie ||
    selectedCarte ||
    article ||
    articleParent
      ? {
          categorie_id: selectedSousCategorie,
          sous_categorie_id: selectedSousCategorie,
          carte_id: selectedCarte,
          article_id: article?.article ? article?.article?._id : article,
          articleParent: articleParent,
          min: min,
          max: max,
          type: conditionProduitType,
          organisation_id: currentOrg,
          fournisseur: fournisseur,
          remise_id: type === "remise" ? "" : null,
          gratuite_id: type === "gratuite" ? "" : null,
          fidelite_id: type === "fidelite" ? "" : null,
          cumulable: cumulableproduit,
        }
      : null;
  console.log("conditionProduit", conditionProduit);
  let conditionAchat = montant
    ? {
        montant_achat: montant,
        organisation_id: currentOrg,
        remise_id: type === "remise" ? "" : null,
        gratuite_id: type === "gratuite" ? "" : null,
        fidelite_id: type === "fidelite" ? "" : null,
      }
    : null;
  useEffect(() => {
    setConditionAchat(conditionAchat);
    setConditionClient(conditionClient);
    setConditionProduit(conditionProduit);
  }, [conditionAchat, conditionClient, conditionProduit]);
  useEffect(() => {
    if (programFidelite !== null) {
      const conditions_produits = programFidelite?.conditions_produits[0];
      setArticle((conditions_produits?.article_id as any)?._id || null);
      setSelectedSousCategorie(
        conditions_produits?.sous_categorie_id?._id || null,
      );
      setSelectedSousCategorienom(
        conditions_produits?.sous_categorie_id?.libelle?.fr,
      );
      setInputValue(
        (conditions_produits?.article_id as any)?.titre?.fr || null,
      );
      setMax(Number(conditions_produits?.max));
      setMin(Number(conditions_produits?.min));
      setRand(!rand);

      const conditions_achats = programFidelite?.conditions_achats[0];
      setMontant(conditions_achats?.montant_achat);
      const conditions_clients = programFidelite?.conditions_clients[0];

      setNiveauClient([conditions_clients?.niveau_fidelite]);
      // setConditionAchat(programFidelite.conditions_achats)
      // setConditionClient(programFidelite.conditions_clients)
    }
  }, [programFidelite]);
  const parametrage = useAppSelector(parametrageCaisse);
  const [loadingsearch, setloadingsearch] = useState(false);

  const TypeInputParametrage = parametrage?.SearchCaisse;

  const [TypeInput, setTypeInput] = useState(TypeInputParametrage);
  const debouncedSearch = useCallback(
    debounce(async (barcode: string, TypeInput: string) => {
      setloadingsearch(true);
      if (TypeInput === "Parent") {
        const resultReference = await dispatch(
          findArticleParentCode({ code: barcode, societe: societe }),
        );
        if (resultReference.payload) {
          setInputParentValue(resultReference?.payload?.titre?.fr);
          setarticleParent(resultReference?.payload?._id);
        }
        setloadingsearch(false);
      } else if (TypeInput === "codeBarre") {
        const resultArticle = await dispatch(
          findArticleByBarCode({ inputValue: barcode, societe }),
        );
        if (resultArticle.payload) {
          setloadingsearch(false);
          setArticle(resultArticle.payload._id);
          setInputValue(resultArticle.payload?.titre?.fr);
          // setRand(!rand);
        } else {
          setArticle(null);
          setloadingsearch(false);
        }
      } else {
        const resultReference = await dispatch(
          findArticleRefParentApi({ ref: barcode, societe_id: societe }),
        );
        setInputValue(article?.article?.titre?.fr);
        if (resultReference.payload) {
          const list = resultReference?.payload?.map((e: any) => {
            return { article: e };
          });
          console.log("list", list);
          SelectArticles(list);
          setShowArticlesModal(true);
        }
        setloadingsearch(false);
      }
    }, 1000), // Wait 500ms before triggering the search
    [],
  );

  const handleInputArticleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const barcode = event.target.value;
    setInputValue(barcode);

    if (barcode !== "") {
      debouncedSearch(barcode, TypeInput); // Only search after 500ms of no typing
    }
  };

  const handlechangeArticleParent = (e: any) => {
    const barcode = e.target.value;
    setInputParentValue(barcode);

    if (barcode !== "") {
      debouncedSearch(barcode, "Parent"); // Only search after 500ms of no typing
    }
  };

  const handleClearInput = () => {
    setInputValue("");
    setArticle(null);
  };
  const [showArticlesModal, setShowArticlesModal] = useState(false);
  const [articles, SelectArticles] = useState([]);
  useEffect(() => {
    if (article)
      setInputValue(
        article.article ? article.article.titre?.fr : article.titre?.fr,
      );
  }, [article]);
  return (
    <>
      <ArticleListReference
        t={t}
        ShowModal={showArticlesModal}
        setShowModal={setShowArticlesModal}
        selectAricle={setArticle}
        list={articles}
        reference={inputValue}
      />{" "}
      <Tabs
        defaultActiveKey="profile"
        id="fill-tab-example"
        className="mb-3"
        fill
      >
        {solde ? null : (
          <Tab eventKey="client" title={t("Conditions client")}>
            <div className="row">
              <div className="col-12">
                <div>
                  <label htmlFor="niveau">
                    <span style={{ color: "red" }}></span>
                    {t("Categorie client")}
                  </label>
                </div>

                <Select
                  isMulti
                  options={categorieClientOptions}
                  isSearchable={true}
                  onChange={handleSelectChangecategorieClient}
                  value={niveauClient?.map((item: any) =>
                    categorieClientOptions?.find(
                      (cat: any) => cat.value === item,
                    ),
                  )}
                />
              </div>
              {/* <div className="col-6">
                <div className="form-group">
                  <label htmlFor="Zone">
                    {" "}
                    <span style={{ color: "red" }}></span>
                    {t("Zone")}
                  </label>
                  <select
                    className="form-control mb-2"
                    onChange={(e) => {
                      setZone(e.currentTarget.value);
                      setRand(!rand);
                    }}
                  >
                    <option value="">{t("Choisir une zone")} </option>
                    {zones?.map((item: any) => (
                      <option key={item._id} value={item._id}>
                        {item.libelle}
                      </option>
                    ))}
                  </select>
                </div>
              </div> */}
            </div>
            <div className="row"></div>
          </Tab>
        )}
        {solde ? null : (
          <Tab eventKey="achat" title={t("Conditions Achat")}>
            <div className="row">
              <div className="col-6">
                <div className="form-group">
                  <label htmlFor="montant">
                    {" "}
                    <span style={{ color: "red" }}></span>
                    {t("Montant minimum d'achat")}
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    id="montant"
                    value={montant?.toString()}
                    onChange={(e) => {
                      //
                      setMontant(Number(e.currentTarget.value));
                      setRand(!rand);
                    }}
                  />
                </div>
              </div>
              <div className="col-6">
                <div className="form-group">
                  <label htmlFor="cumulable">
                    {" "}
                    <span style={{ color: "red" }}></span>
                    {t("Cumulable")}
                  </label>
                  <input
                    className="m-2"
                    checked={cumulableachat}
                    type="checkbox"
                    id="cumulable"
                    onChange={(e) => {
                      setCumulableachat(!cumulableachat);
                      setRand(!rand);
                    }}
                  />
                </div>
              </div>
            </div>
          </Tab>
        )}

        <Tab eventKey="produit" title="Conditions Produits">
          {/* <button onClick={() => console.log(solde)}>test</button> */}

          <div className="row">
            <div className="col-6">
              <div className="form-group">
                <label htmlFor="carte">
                  {" "}
                  <span style={{ color: "red" }}></span>
                  {t("Carte")}
                </label>
                <Select
                  value={selectedCarte?.label}
                  onChange={(e) => handleChange(e, "carte")}
                  options={CartesOptions}
                  isSearchable={true}
                />
              </div>
            </div>
            <div className="col-6">
              <div className="form-group">
                <label htmlFor="categorie">
                  {" "}
                  <span style={{ color: "red" }}></span>
                  {t("Categorie")}
                </label>
                <Select
                  value={selectedCategorie?.label}
                  onChange={(e) => handleChange(e, "categorie")}
                  options={categoriesdOptions}
                  isSearchable={true}
                  isDisabled={selectedCarte ? false : true}
                />{" "}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <div className="form-group">
                <label htmlFor="Sous Categories">{t("Sous Categories")} </label>
              </div>

              <div className="custom-dropdown">
                <div
                  className="form-control"
                  onClick={() => setIsOpen(!isOpen)}
                >
                  {selectedSousCategorienom !== null
                    ? selectedSousCategorienom
                    : "Select category"}
                </div>
                {isOpen && (
                  <div className="custom-dropdown-options">
                    {indexcat > 1 && (
                      <div
                        className="custom-dropdown-option"
                        onClick={() => showsouscategories("up")}
                      >
                        <i className="fas fa-arrow-up"></i>
                      </div>
                    )}
                    {sousCategories?.map((option, i) => (
                      <div
                        key={i}
                        className="custom-dropdown-option"
                        onClick={() => showsouscategories(option)}
                      >
                        {option?.libelle?.fr}
                      </div>
                    ))}

                    <div
                      className="custom-dropdown-option"
                      onClick={() => showsouscategories("more")}
                    >
                      <i className="fas fa-arrow-down"></i>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="col-6">
              <div className="form-group">
                <label htmlFor="Article">
                  {" "}
                  <span style={{ color: "red" }}></span>
                  {t("Article")}
                </label>
                <div className="input-button" style={{ display: "flex" }}>
                  <input
                    value={inputValue}
                    onChange={(e) => {
                      handleInputArticleChange(e);
                    }}
                    type="text"
                    className="form-control"
                    id="Article"
                  />
                  {loadingsearch ? (
                    <div
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Spinner animation="border" role="status" size="sm">
                        <span className="visually-hidden">Loading...</span>
                      </Spinner>
                    </div>
                  ) : (
                    <div
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {TypeInput === "codeBarre" ? (
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={() => setTypeInput("ref")}
                          style={{
                            width: "52px",
                            height: "40px",
                            position: "absolute",
                            right: inputValue ? "43px" : "6px",
                            top: "-12px",
                          }}
                        >
                          CB
                        </button>
                      ) : (
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={() => setTypeInput("codeBarre")}
                          style={{
                            width: "52px",
                            height: "40px",
                            position: "absolute",
                            right: inputValue ? "43px" : "6px",
                            top: "-12px",
                          }}
                        >
                          REF
                        </button>
                      )}
                    </div>
                  )}
                  {inputValue && (
                    <button
                      onClick={handleClearInput}
                      className="btn btn-danger"
                      style={{
                        height: "40px",
                        top: "35px",
                        position: "absolute",
                        right: "14px",
                      }}
                    >
                      <i className="fas fa-times"></i>
                    </button>
                  )}
                </div>
              </div>
            </div>
            <div className="col-6">
              <div className="form-group">
                <label htmlFor="Article">
                  {" "}
                  <span style={{ color: "red" }}></span>
                  {t("Article Parent")}
                </label>
                <div className="input-button" style={{ display: "flex" }}>
                  <input
                    value={inputParentValue}
                    onChange={(e) => {
                      handlechangeArticleParent(e);
                    }}
                    type="text"
                    className="form-control"
                    id="Article"
                  />
                  {loadingsearch ? (
                    <div
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Spinner animation="border" role="status" size="sm">
                        <span className="visually-hidden">Loading...</span>
                      </Spinner>
                    </div>
                  ) : (
                    <div></div>
                  )}
                  {inputValue && (
                    <button
                      onClick={handleClearInput}
                      className="btn btn-danger"
                      style={{
                        height: "40px",
                        top: "35px",
                        position: "absolute",
                        right: "14px",
                      }}
                    >
                      <i className="fas fa-times"></i>
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-6">
              <div className="form-group">
                <label htmlFor="quantity">
                  {" "}
                  <span style={{ color: "red" }}></span>
                  {t("Quantite / chiffre min")}
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="quantite"
                  defaultValue={1}
                  value={min?.toString()}
                  onChange={(e) => {
                    setMin(Number(e.currentTarget.value));
                    setRand(!rand);
                  }}
                />
              </div>
            </div>
            <div className="col-6">
              <div className="form-group">
                <label htmlFor="quantity">
                  {" "}
                  <span style={{ color: "red" }}></span>
                  {t("Quantite / chiffre max")}
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="quantite"
                  defaultValue={1000}
                  value={max?.toString()}
                  onChange={(e) => {
                    setMax(Number(e.currentTarget.value));
                    setRand(!rand);
                  }}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-4">
              <div className="form-group">
                <label>
                  Quantité <span style={{ color: "red" }}></span>
                </label>
                <input
                  className="m-2"
                  defaultChecked
                  type="radio"
                  id="quantite1"
                  name="quantite"
                  onChange={(e) => {
                    setconditionProduitType("Quantité");
                    setRand(!rand);
                  }}
                />
                <label htmlFor="quantite1">
                  Chiffre <span style={{ color: "red" }}></span>
                </label>
                <input
                  className="m-2"
                  type="radio"
                  id="quantite2"
                  name="quantite"
                  onChange={(e) => {
                    setconditionProduitType("Chiffre");
                    setRand(!rand);
                  }}
                />
              </div>
            </div>
          </div>
          {/* <button onClick={() => console.log(conditionProduit)}></button> */}
        </Tab>
      </Tabs>
    </>
  );
}

export default ConditionForms;
